import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const CloseTemplateTaskBulkRoleCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedCloseTemplateTaskCount = 0,
        closeTemplateTaskBulkRoleOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set role for ${selectedCloseTemplateTaskCount} ${pluralize("task", selectedCloseTemplateTaskCount)}`}
            options={closeTemplateTaskBulkRoleOptions}
        />
    );
};
